module.exports = __webpack_public_path__ + "static/img/horse.c427d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/horse.png
// module id = gvwz
// module chunks = 0